import { put, takeLatest } from "redux-saga/effects";
import {
  CREATE_CHAT_ROOM_INIT,
  CREATE_CHAT_ROOM_SUCCESS,
  CREATE_CHAT_ROOM_FAILED,
  CREATE_CHAT_ROOM,
  GET_FUND_MANAGERS_REQUEST,
  GET_FUND_MANAGERS_SUCCESS,
  GET_FUND_MANAGERS_FAILED,
  GET_FUND_MANAGERS_ACTION,
  GET_HEDGE_USER_FREE_SLOTS_ACTION,
  GET_HEDGE_USER_FREE_SLOTS_REQUEST,
  GET_HEDGE_USER_FREE_SLOTS_SUCCESS,
  GET_HEDGE_USER_FREE_SLOTS_FAILED,
  GET_ALL_USERS_ACTION,
  GET_ALL_USERS_REQUEST,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_FAILED,
  CREATE_APPOINTMENT_REQUEST,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_FAILED,
  CREATE_APPOINTMENT_ACTION,
  INVEST_IN_FUND,
  INVEST_IN_FUND_REQUEST,
  INVEST_IN_FUND_SUCCESS,
  INVEST_IN_FUND_FAILED,
  CREATE_NOTES,
  CREATE_NOTES_INIT,
  CREATE_NOTES_SUCCESS,
  CREATE_NOTES_FAILED,
  GET_NOTES,
  GET_NOTES_INIT,
  GET_NOTES_SUCCESS,
  GET_NOTES_FAILED,
  SEARCH_PMRESULT_FAILED,
  SEARCH_PMRESULT,
  SEARCH_PMRESULT_INIT,
  SEARCH_PMRESULT_SUCCESS,
  SEARCH_RPRESULT_SUCCESS,
  SEARCH_RPRESULT_FAILED,
  SEARCH_RPRESULT_INIT,
  SEARCH_REPORTRESULT_INIT,
  SEARCH_REPORTRESULT_SUCCESS,
  SEARCH_REPORTRESULT_FAILED,
  SEARCH_REPORTRESULT,
  SEARCH_RPRESULT,
  CREATE_AUDITLOGS_INIT,
  CREATE_AUDITLOGS_SUCCESS,
  CREATE_AUDITLOGS_FAILED,
  CREATE_AUDITLOGS,
  GET_ALL_ADMIN_LIST_INIT,
  GET_ALL_ADMIN_LIST_SUCCESS,
  GET_ALL_ADMIN_LIST_FAILED,
  GET_ALL_ADMIN_LIST,
  GET_ALLOCATOR_USERS_INIT,
  GET_ALLOCATOR_USERS_SUCCESS,
  GET_ALLOCATOR_USERS_FAILED,
  GET_ALLOCATOR_USERS,
  GET_HEDGEFUND_DETAIL_INIT,
  GET_HEDGEFUND_DETAIL_SUCCESS,
  GET_HEDGEFUND_DETAIL_FAILED,
  GET_HEDGEFUND_DETAIL,
  GET_FUND_DETAILS_INIT,
  GET_FUND_DETAILS_SUCCESS,
  GET_FUND_DETAILS_FAILED,
  GET_FUND_DETAILS,
  GET_FUND_BIO_USER_INIT,
  GET_FUND_BIO_USER_SUCCESS,
  GET_FUND_BIO_USER_FAILED,
  GET_FUND_BIO_USER,
} from "./constants";
import { getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";

export function* getHedgeFundDetail({ id }) {
  yield put({ type: GET_HEDGEFUND_DETAIL_INIT });
  try {
    const res = yield getUtil(`${API.GetHedgeFund}?id=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_HEDGEFUND_DETAIL_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_HEDGEFUND_DETAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* createRoom({ payload, callback }) {
  yield put({ type: CREATE_CHAT_ROOM_INIT });
  try {
    const res = yield postUtil(API.CreateRoom, payload);
    if (res?.status === 200) {
      callback(res.data.result.id);
      yield put({ type: CREATE_CHAT_ROOM_SUCCESS });
    } else {
      yield put({ type: CREATE_CHAT_ROOM_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getFundManagers({ id }) {
  yield put({ type: GET_FUND_MANAGERS_REQUEST });
  try {
    const res = yield getUtil(`${API.fundManagers}?id=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_FUND_MANAGERS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_FUND_MANAGERS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getHedgeUserSlots({ payload }) {
  const { monthDate, userId, duration } = payload || {};
  yield put({ type: GET_HEDGE_USER_FREE_SLOTS_REQUEST });
  try {
    const res = yield getUtil(
      `${API.freeSlots}?monthDate=${monthDate}&userId=${userId}&duration=${duration}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_HEDGE_USER_FREE_SLOTS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: GET_HEDGE_USER_FREE_SLOTS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getUsers() {
  yield put({ type: GET_ALL_USERS_REQUEST });
  try {
    const res = yield getUtil(`${API.getUsers}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_ALL_USERS_SUCCESS,
        payload: data.result.items,
      });
    } else {
      yield put({ type: GET_ALL_USERS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* appointmentCreation({ payload, onSuccess }) {
  yield put({ type: CREATE_APPOINTMENT_REQUEST });
  try {
    const res = yield postUtil(`${API.CreateAppointment}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: CREATE_APPOINTMENT_SUCCESS,
        payload: data.result,
      });
      onSuccess(data.result.id);
    } else {
      yield put({ type: CREATE_APPOINTMENT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* investInFund({ payload }) {
  yield put({ type: INVEST_IN_FUND_REQUEST });
  try {
    const res = yield postUtil(`${API.Invest}`, payload);
    if (res?.status === 200) {
      yield put({
        type: INVEST_IN_FUND_SUCCESS,
        id: payload.fundId,
        selectedInvestorId: res?.data?.result.id
      });
    } else {
      yield put({ type: INVEST_IN_FUND_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}


export function* createNotes({ payload, onSuccessAlert, onCloseModal }) {
  yield put({ type: CREATE_NOTES_INIT });
  try {
    const res = yield postUtil(`${API.CreateNotes}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: CREATE_NOTES_SUCCESS, payload: data.result });
      onSuccessAlert();
      onCloseModal();
    } else {
      yield put({ type: CREATE_NOTES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getFundNotes({ id,callback }) {
  yield put({ type: GET_NOTES_INIT });
  try {
    const res = yield getUtil(`${API.GetNotes}?fundId=${id}`);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_NOTES_SUCCESS, payload: data.result });
      // if(callback) 
      // {
      //   callback();
      // }
    } else {
      yield put({ type: GET_NOTES_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* getPerformanceMetricsSearchResult({ payload }) {
  const { id, year } = payload || {};
  yield put({ type: SEARCH_PMRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.GetPerformanceMetricsSearchResult}?fundId=${id}&year=${year}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_PMRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_PMRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* GetRiskReportSearchResult({ payload }) {
  const { 
    id, 
    // year 
  } = payload || {};
  yield put({ type: SEARCH_RPRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.GetRiskReportSearchResult}?fundId=${id}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_RPRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_RPRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* RiskReportSearchResultByMonth({ payload }) {
  const { id, month , riskReportType } = payload || {};
  yield put({ type: SEARCH_REPORTRESULT_INIT });
  try {
    const res = yield getUtil(
      `${API.RiskReportSearchResultByMonth}?fundId=${id}&month=${month}&riskReportType=${riskReportType}`
    );
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: SEARCH_REPORTRESULT_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: SEARCH_REPORTRESULT_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* CreateAuditLogs({ payload }) {
  yield put({ type: CREATE_AUDITLOGS_INIT });
  try {
    const res = yield postUtil(API.CreateAuditLogs , payload, window._env_.CHAT_API_URL);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: CREATE_AUDITLOGS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: CREATE_AUDITLOGS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getFCNTenants() {
  yield put({ type: GET_ALL_ADMIN_LIST_INIT });
  try {
    const res = yield getUtil(API.fcnAdminList);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_ALL_ADMIN_LIST_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALL_ADMIN_LIST_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getAllocatorUsers({ payload }) {
  try {
      yield put({ type: GET_ALLOCATOR_USERS_INIT });

      const res = yield getUtil(`${API.GetCompanyUsers}?id=${payload}`);
      if (res?.status === 200) {
          const { data } = res;

          yield put({
              type: GET_ALLOCATOR_USERS_SUCCESS,
              payload: data.result,
          });
      } else {
          yield put({ type: GET_ALLOCATOR_USERS_FAILED });
      }
  } catch (error) {
      throw new Error(error);
  }
}

export function* getFundDetail({ id,setFollowFunds }) {
  yield put({ type: GET_FUND_DETAILS_INIT });
  try {
    const res = yield getUtil(`${API.GetFund}?id=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      setFollowFunds(data?.result?.followed)
      yield put({ type: GET_FUND_DETAILS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_FUND_DETAILS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* getFundBioUsersSaga({ id }) {
  yield put({ type: GET_FUND_BIO_USER_INIT });
  try {
    const res = yield getUtil(`${API.fundBioUsers}?tenantId=${id}`);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_FUND_BIO_USER_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_FUND_BIO_USER_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* hedgeFundDetailSaga() {
  yield takeLatest(CREATE_CHAT_ROOM, createRoom);
  yield takeLatest(GET_HEDGEFUND_DETAIL, getHedgeFundDetail);
  yield takeLatest(GET_FUND_MANAGERS_ACTION, getFundManagers);
  yield takeLatest(GET_HEDGE_USER_FREE_SLOTS_ACTION, getHedgeUserSlots);
  yield takeLatest(GET_ALL_USERS_ACTION, getUsers);
  yield takeLatest(CREATE_APPOINTMENT_ACTION, appointmentCreation);
  yield takeLatest(INVEST_IN_FUND, investInFund);
  yield takeLatest(CREATE_NOTES, createNotes);
  yield takeLatest(GET_NOTES, getFundNotes);
  yield takeLatest(SEARCH_PMRESULT, getPerformanceMetricsSearchResult);
  yield takeLatest(SEARCH_RPRESULT, GetRiskReportSearchResult);
  yield takeLatest(SEARCH_REPORTRESULT, RiskReportSearchResultByMonth);
  yield takeLatest(CREATE_AUDITLOGS, CreateAuditLogs);
  yield takeLatest(GET_ALL_ADMIN_LIST, getFCNTenants);
  yield takeLatest(GET_ALLOCATOR_USERS, getAllocatorUsers);
  yield takeLatest(GET_FUND_DETAILS, getFundDetail);
  yield takeLatest(GET_FUND_BIO_USER, getFundBioUsersSaga);
}
